import { render, staticRenderFns } from "./classificationSelect.vue?vue&type=template&id=40dea348"
import script from "./classificationSelect.vue?vue&type=script&lang=js"
export * from "./classificationSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports